import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaB_Hatchback_Right: React.FC<AreaSVGProps> = ({
  fill = '#148B4D',
  stroke = '#148B4D',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="107"
      height="217"
      viewBox="0 0 107 217"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_b_hatchback_right"
          x="0"
          y="0"
          width="107"
          height="217"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_b_hatchback_right)">
        <path
          d="M0 212.325C4.48784 214.804 10.9363 216.693 16.8818 216.722H16.9346L16.9863 216.723C32.5709 217.203 51.3437 214.397 67.2793 210.95C75.2174 209.233 82.3837 207.372 88.0078 205.716C93.7176 204.034 97.5761 202.638 99.1055 201.877C100.406 201.205 100.77 200.134 100.877 199.588C102.2 159.345 103.696 109.844 104.862 70.3693C105.447 50.5894 105.947 33.3274 106.303 21.0109C106.48 14.8527 106.622 9.93033 106.719 6.54802C106.739 5.8565 106.756 5.22932 106.772 4.66912C82.5818 -0.122215 44.2001 -2.23527 13.5977 3.27556C13.5645 3.698 13.5276 4.16137 13.4883 4.66326C13.2664 7.4964 12.9488 11.5628 12.5654 16.4953C11.7986 26.3608 10.7691 39.6907 9.71777 53.549C7.61115 81.3188 5.42908 111.062 5.08595 119.44L5.08399 119.481V119.485C5.08386 119.487 5.08327 119.491 5.08302 119.496C5.0825 119.506 5.08207 119.522 5.08106 119.541C5.07903 119.581 5.07625 119.64 5.07227 119.717C5.06428 119.873 5.05266 120.104 5.03712 120.406C5.00602 121.011 4.95996 121.9 4.90137 123.035C4.78419 125.306 4.61569 128.565 4.41016 132.516C3.99911 140.418 3.44032 151.09 2.84864 162.172C1.78436 182.106 0.608444 203.458 0 212.325Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
